import React from "react";
import { connect } from "react-redux";
import { Spinner, Row, Col } from "react-bootstrap";
import apiCalls from "../../../redux/actions/ApiCalls";

function Loading(props) {
  const style = {};
  return props.activeApis[apiCalls[props.api]] ? (
    <Row>
      <Col />
          <Col xs="auto">
              <Spinner animation="border" size={props.small ? "sm" : ""} style={style} />
        <span>{props.children}</span>
      </Col>
      <Col />
    </Row>
  ) : (
    <></>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    activeApis: state.activeApis
  };
}

export default connect(mapStateToProps)(Loading);
